import {
  GET_USER_MESSAGES,
  GET_ALL_USERS_LIST,
  ADD_ADMIN_MESSAGE,
  ADD_USER_MESSAGE,
  UPDATE_MESSAGE_STATUS,
  SET_SOCKET_CONNECTION_STATUS,
  SET_TYPING_INDICATOR,
  UPDATE_USER_STATUS,
  REMOVE_OPTIMISTIC_MESSAGE,
  CLEAR_CHAT_HISTORY,
} from '../types'

const INITIAL_STATE = {
  chatusereducer: { success: false, message: '', data: [] },
  getAllUsersList: [],
  socketStatus: { connected: false, socketId: null, error: null },
  typingIndicators: {},
  userStatuses: {},
  lastMessageTimestamp: null,
  unreadCount: 0,
}

const chatConversationReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_USER_MESSAGES: {
      const incoming = Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload)
        ? payload
        : []
      const sorted = [...incoming].sort(
        (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      )

      return {
        ...state,
        chatusereducer: {
          success: true,
          message: 'Messages updated',
          data: sorted,
        },
        lastMessageTimestamp: payload?.timestamp || new Date().toISOString(),
        unreadCount: sorted.filter((msg) => !msg.isRead).length,
      }
    }

    case ADD_ADMIN_MESSAGE: {
      const existingData = Array.isArray(state.chatusereducer.data)
        ? state.chatusereducer.data
        : []
      const newMsg = payload && typeof payload === 'object' ? payload : {}

      // Check if message already exists to avoid duplicates
      const messageExists = existingData.some(
        (msg) =>
          msg.adminMessageId === newMsg.adminMessageId ||
          msg.tempId === newMsg.tempId,
      )

      if (messageExists) {
        return state
      }

      return {
        ...state,
        chatusereducer: {
          ...state.chatusereducer,
          data: [...existingData, newMsg],
        },
        lastMessageTimestamp: new Date().toISOString(),
        unreadCount: state.unreadCount + 1,
      }
    }

    case ADD_USER_MESSAGE: {
      const existingData = Array.isArray(state.chatusereducer.data)
        ? state.chatusereducer.data
        : []
      const newMsg = payload && typeof payload === 'object' ? payload : {}

      // Check if message already exists to avoid duplicates
      const messageExists = existingData.some(
        (msg) =>
          msg.userMessageId === newMsg.userMessageId ||
          msg.tempId === newMsg.tempId,
      )

      if (messageExists) {
        return state
      }

      return {
        ...state,
        chatusereducer: {
          ...state.chatusereducer,
          data: [...existingData, newMsg],
        },
        lastMessageTimestamp: new Date().toISOString(),
        unreadCount: state.unreadCount + 1,
      }
    }

    case UPDATE_MESSAGE_STATUS: {
      const { tempId, realMessageId, status, readBy, readAt } = payload
      const existingData = Array.isArray(state.chatusereducer.data)
        ? state.chatusereducer.data
        : []

      const updatedData = existingData.map((msg) => {
        // Update optimistic messages with real data
        if (msg.tempId === tempId) {
          return {
            ...msg,
            tempId: undefined, // Remove temp ID
            adminMessageId: realMessageId,
            status: status || 'sent',
            isOptimistic: false,
            readBy: readBy || msg.readBy,
            readAt: readAt || msg.readAt,
            isRead: true,
          }
        }

        // Update existing messages by ID
        if (
          msg.userMessageId === realMessageId ||
          msg.adminMessageId === realMessageId
        ) {
          return {
            ...msg,
            status: status || msg.status,
            readBy: readBy || msg.readBy,
            readAt: readAt || msg.readAt,
            isRead: true,
          }
        }
        return msg
      })

      return {
        ...state,
        chatusereducer: {
          ...state.chatusereducer,
          data: updatedData,
        },
        unreadCount: updatedData.filter((msg) => !msg.isRead).length,
      }
    }

    case GET_ALL_USERS_LIST:
      
      return {
        ...state,
        getAllUsersList: payload || [],
        lastMessageTimestamp:
          payload?.lastUpdated || state.lastMessageTimestamp,
      }

    case SET_SOCKET_CONNECTION_STATUS:
      return {
        ...state,
        socketStatus: {
          ...state.socketStatus,
          ...payload,
        },
      }

    case SET_TYPING_INDICATOR: {
      const { userId, isTyping, groupId } = payload
      return {
        ...state,
        typingIndicators: {
          ...state.typingIndicators,
          [userId]: { isTyping, groupId, timestamp: new Date().toISOString() },
        },
      }
    }

    case UPDATE_USER_STATUS: {
      const { userId, status, lastSeen, groupId } = payload
      return {
        ...state,
        userStatuses: {
          ...state.userStatuses,
          [userId]: {
            status,
            lastSeen,
            groupId,
            timestamp: new Date().toISOString(),
          },
        },
      }
    }

    case REMOVE_OPTIMISTIC_MESSAGE: {
      const existingData = Array.isArray(state.chatusereducer.data)
        ? state.chatusereducer.data
        : []

      const filteredData = existingData.filter((msg) => msg.tempId !== payload)

      return {
        ...state,
        chatusereducer: {
          ...state.chatusereducer,
          data: filteredData,
        },
        unreadCount: filteredData.filter((msg) => !msg.isRead).length,
      }
    }

    case CLEAR_CHAT_HISTORY:
      return {
        ...state,
        chatusereducer: { success: false, message: '', data: [] },
        lastMessageTimestamp: null,
        unreadCount: 0,
      }

    default:
      return state
  }
}

export default chatConversationReducer
